import { c as _c } from "react/compiler-runtime";
import type { PropsWithChildren, Ref } from 'react';
import type { VariantProps } from 'tailwind-variants';
import { tv } from 'tailwind-variants';
const containerVariants = tv({
  base: 'scrollbar-none group-data-hover/card:brightness-110 flex size-full flex-none snap-mandatory rounded-2xl group-hover/card:brightness-110 group-active/card:brightness-125',
  variants: {
    orientation: {
      horizontal: 'snap-x flex-row overflow-y-hidden',
      vertical: 'snap-y flex-col overflow-x-hidden'
    },
    corners: {
      rounded: 'rounded-2xl',
      none: 'rounded-none'
    }
  },
  defaultVariants: {
    orientation: 'horizontal'
  }
});
export type ImageSliderContainerProps = PropsWithChildren & VariantProps<typeof containerVariants> & {
  className?: string;
  aspectRatio?: number;
  ref?: Ref<HTMLUListElement>;
};
export function ImageSliderContainer(props) {
  const $ = _c(13);
  let children;
  let className;
  let ref;
  let rest;
  if ($[0] !== props) {
    ({
      ref,
      className,
      children,
      ...rest
    } = props);
    $[0] = props;
    $[1] = children;
    $[2] = className;
    $[3] = ref;
    $[4] = rest;
  } else {
    children = $[1];
    className = $[2];
    ref = $[3];
    rest = $[4];
  }
  let t0;
  if ($[5] !== className || $[6] !== rest) {
    t0 = containerVariants({
      className,
      ...rest
    });
    $[5] = className;
    $[6] = rest;
    $[7] = t0;
  } else {
    t0 = $[7];
  }
  let t1;
  if ($[8] !== children || $[9] !== ref || $[10] !== rest || $[11] !== t0) {
    t1 = <ul className={t0} ref={ref} {...rest}>{children}</ul>;
    $[8] = children;
    $[9] = ref;
    $[10] = rest;
    $[11] = t0;
    $[12] = t1;
  } else {
    t1 = $[12];
  }
  return t1;
}